<!--
 * @Descripttion: 个人中心页面组件
 * @Author: congz
 * @Date: 2020-07-03 09:31:23
 * @LastEditors: congz
 * @LastEditTime: 2020-08-19 11:38:48
--> 

<template>
  <div class="center" id="center" name="center">
    <div class="center-layout">
      <el-row :gutter="10">
        <div>
          <CenterMenu></CenterMenu>
        </div>
        <el-col :span="20">
          <div class="center-content">
            <!--个人信息头部-->
            <div class="center-user">
              <div class="user-avator">
                <img :src="this.$store.getters.getUser.avatar" @error="handleAvatarError" />
              </div>
              <div class="user-info">
                <p
                  style="font-size:25px;font-weight:100;color:#464547"
                >{{this.$store.getters.getUser.nickname}}</p>
                <p>
                  <router-link to="/user/details" style="font-size:13px;color:#C75D3D;">Modify personal information</router-link>
                </p>
              </div>
              <div class="user-message">
                <ul>
                  <li>Account Security :</li>
                  <li>Bind email :</li>
                </ul>
              </div>
              <div class="user-data">
                <ul>
                  <li>General</li>
                  <li v-if="this.$store.getters.getUser.email==''">
                    Click
                    <a href="javascript:;" @click="addVisible=true">Bind email</a>
                  </li>
                  <li v-else>
                    {{this.$store.getters.getUser.email}}
                    <a
                      href="javascript:;"
                      @click="deleteVisible=true"
                      style="color: darkred"
                    >Unbind</a>
                  </li>
                </ul>
              </div>
            </div>
            <!--end--个人信息头部-->
            <div class="user-details">
              <div class>
                <img src="https://s01.mifile.cn/i/user/portal-icon-1.png" />
              </div>
              <div class="operate1">
                <p class="oper-title">Pending Payment Order :{{notPayTotal}}</p>
                <p>
                  <router-link :to="{ path: '/order', query: {type:1} }" class="oper-href">Unpaid orders ></router-link>
                </p>
              </div>
              <div class="operate">
                <img src="https://s01.mifile.cn/i/user/portal-icon-2.png" />
              </div>
              <div class="operate1">
                <p class="oper-title">Paid orders :{{payTotal}}</p>
                <p>
                  <router-link :to="{ path: '/order', query: {type:2} }" class="oper-href">View paid orders </router-link>
                </p>
              </div>
            </div>
            <div class="user-details1">
              <div class>
                <img src="https://s01.mifile.cn/i/user/portal-icon-3.png" />
              </div>
              <div class="operate1">
                <p class="oper-title">Product to be evaluated ：0</p>
                <p>
                  <router-link to class="oper-href">View orders to be evaluated ></router-link>
                </p>
              </div>
              <div class="operate">
                <img src="https://s01.mifile.cn/i/user/portal-icon-4.png" />
              </div>
              <div class="operate1">
                <p class="oper-title">Collected products ：{{favoriteTotal}}</p>
                <p>
                  <router-link :to="{ path: '/favorite'}" class="oper-href">View Favorite Products ></router-link>
                </p>
              </div>
            </div>
          </div>
          <!-- 绑定邮箱弹出框 -->
          <el-dialog title="Bind email" :visible.sync="addVisible" width="30%" center>
            <el-form ref="form" :model="form" label-width="70px">
              <el-form-item
                prop="email"
                label="Email"
                :rules="[
      { required: true, message: 'Please enter your email address', trigger: 'blur' },
      { type: 'email', message: 'Please enter the correct email address', trigger: ['blur', 'change'] }
    ]"
              >
                <el-input v-model="form.email"></el-input>
              </el-form-item>
              <p>{{message}}</p>
            </el-form>
            <span slot="footer" class="dialog-footer">
              <el-button
                type="primary"
                @click="postEmail('form')"
                :disabled="cannotClick"
              >{{content}}</el-button>
            </span>
          </el-dialog>
          <!-- 绑定邮箱弹出框END -->
          <!-- 绑定邮箱弹出框 -->
          <el-dialog title="Unbind" :visible.sync="deleteVisible" width="30%" center>
            <p>{{deleteMessage}}</p>
            <span slot="footer" class="dialog-footer">
              <el-button type="primary" @click="deleteEmail()" :disabled="cannotClick">{{content}}</el-button>
            </span>
          </el-dialog>
          <!-- 新建收货地址弹出框END -->
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import CenterMenu from '../components/CenterMenu'
import * as userAPI from '@/api/users'
import * as countAPI from '@/api/count'
export default {
  name: 'Center',
  data() {
    return {
      favoriteTotal: 0,
      notPayTotal: 0,
      payTotal: 0,
      addVisible: false,
      deleteVisible: false,
      content: 'Send verification email',
      message: 'We will send a verification email to your email, which will serve as your binding email',
      deleteMessage: 'We will send a verification email to your email, which will unbind the email',
      cannotClick: false,
      totalTime: 30,
      form: {
        user_id: 0,
        email: '',
        //1:绑定，2:解绑
        operation_type: 0
      }
    }
  },
  methods: {
    //按钮点击计时器
    countDown() {
      if (this.cannotClick) return //改动的是这两行代码
      this.cannotClick = true
      this.content = this.totalTime + 's Resend later'
      let clock = window.setInterval(() => {
        this.totalTime--
        this.content = this.totalTime + 's Resend later'
        if (this.totalTime < 0) {
          window.clearInterval(clock)
          this.content = 'Resend verification email'
          this.message =
            'We will send a verification email to your email, which will serve as your binding email'
          this.deleteMessage =
            'We will send a verification email to your email, which will unbind the email'
          this.totalTime = 30
          this.cannotClick = false //这里重新开启
        }
      }, 1000)
    },
    // 默认头像处理
    handleAvatarError(e) {
      e.target.src = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 24 24" fill="%234A6FA5" stroke="%234A6FA5" stroke-width="1"%3E%3Ccircle cx="12" cy="8" r="4"/%3E%3Cpath d="M4 20c0-4 4-6 8-6s8 2 8 6"/%3E%3C/svg%3E'
    },
    postEmail(formName) {
      this.$refs[formName].validate(valid => {
        if (!valid) {
          return false
        }
        this.countDown()
        this.form.operation_type = 1
        this.form.user_id = this.$store.getters.getUser.id
        userAPI.sendEmail(this.form).then(res => {
          if (res.status === 200) {
            this.message =
              'The verification email has been sent to your email and is valid for 15 minutes. If you have not received it, please check your spam folder. If you still have not received it, please fill in your email again'
          } else {
            this.notifyError('Sending email failed', res.msg)
          }
        })
      })
    },
    deleteEmail() {
      this.countDown()
      this.form.operation_type = 2
      this.form.user_id = this.$store.getters.getUser.id
      this.form.email = this.$store.getters.getUser.email
      userAPI.sendEmail(this.form).then(res => {
        if (res.status === 200) {
          this.deleteMessage =
            'The verification email has been sent to your email and is valid for 15 minutes. If you have not received it, please check your spam folder. If you still have not received it, please resend it\n'
        } else {
          this.notifyError('Sending email failed', res.msg)
        }
      })
    },
    getCount() {
      countAPI
        .showCount(this.$store.getters.getUser.id)
        .then(res => {
          if (res.status === 200) {
            this.favoriteTotal = res.data.favorite_total
            this.notPayTotal = res.data.not_pay_total
            this.payTotal = res.data.pay_total
          } else if (res.status === 20001) {
            //token过期，需要重新登录
            this.loginExpired(res.msg)
          } else {
            this.notifyError('Failed to obtain quantity', res.msg)
          }
        })
        .catch(err => {
          this.notifyError('Failed to obtain quantity', err)
        })
    }
  },
  created() {
    this.getCount()
  },
  components: {
    CenterMenu
  }
}
</script>
<style scoped>
.center-layout {
  max-width: 1225px;
  margin: 0 auto;
}
.center-content {
  background-color: #ffffff;
  margin-bottom: 30px;
}
.center-user {
  height: 280px;
  width: 800px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  padding: 0;
  border-bottom: 1px solid #c2c4ca;
}
.user-avator img {
  width: 150px;
  height: 150px;
  border-radius: 50%;
  padding: 5px;
  border: 1px solid #ddd;
}
.user-info {
  width: 260px;
  line-height: 30px;
  margin-left: 15px;
  padding: 0;
}
.user-message {
  line-height: 30px;
  padding: 0;
}
.user-message ul li {
  color: #77787b;
  font-size: 15px;
}
.user-data {
  line-height: 30px;
  padding: 0;
}
.user-data ul li {
  color: #77787b;
  font-size: 15px;
}
.user-data ul li a {
  color: #77787b;
}
.user-data ul li a:hover {
  color: #C75D3D;
}
.user-details {
  height: 150px;
  width: 800px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  margin-top: 50px;
}
.user-details1 {
  height: 150px;
  width: 800px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  padding-bottom: 50px;
}
.operate {
  margin-left: 150px;
}
.operate1 {
  line-height: 30px;
  margin-left: 20px;
}
.operate1 .oper-title {
  font-size: 20px;
  color: #7b7f86;
}
.operate1 .oper-href {
  font-size: 15px;
  color: #7b7f86;
}
.operate1 .oper-href:hover {
  color: #C75D3D;
}

.email-pop-out {
  text-align: center;
}
/* 手机端适配 */
@media (max-width: 900px) {
  .center-layout {
    max-width: 100%;
    padding: 0 12px 16px;
  }
  .center-content {
    margin-bottom: 16px;
  }
  .center-user,
  .user-details,
  .user-details1 {
    width: 100%;
    height: auto;
    padding: 12px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px 12px;
  }
  .user-avator img {
    width: 90px;
    height: 90px;
  }
  .user-info {
    width: auto;
    margin-left: 8px;
  }
  .user-message,
  .user-data {
    width: 100%;
  }
  .operate {
    margin-left: 0;
  }
  .operate1 {
    margin-left: 12px;
  }
  .operate1 .oper-title {
    font-size: 16px;
  }
  .operate1 .oper-href {
    font-size: 13px;
  }
}
</style>
